'use client'
import { TypeLang } from '@/schema'
import { designGrid, mq, vw } from '@/styles'
import { type FC } from 'react'
import styled from 'styled-components'
import { NAVBAR_HEIGHTS } from './commons/layout/Navbar'

type Props = {
  lang: TypeLang
}

export const MainConfigurator:FC<Props> = ({ lang }) => {

  return (
    <Main>
      <section>
        <iframe id='infinity' src={`https://nexia.contentsort.com/${lang === 'es' ? '?lang=2' : ''}`} />
      </section>
    </Main>
  )
}

const Main = styled.main`
  ${designGrid({})}
  overflow-x: hidden;
  padding: 0;
  position: relative;
  height: 100vh;
  height: 100dvh;
  align-items: center;
  margin-top: ${vw(NAVBAR_HEIGHTS.mobile + 10, 'mobile')};

  ${mq.greaterThan('nexus7')} {
    margin-top: ${vw(NAVBAR_HEIGHTS.mobile + 10, 'tablet')};
  }

  ${mq.greaterThan('tablet')} {
    margin-top: ${vw(NAVBAR_HEIGHTS.desktop + 10, 'desktop')};
    overflow-x: inherit;
  }

  section {
    grid-column: 1 / span 6;

    ${mq.greaterThan('tablet')} {
      grid-column: 2 / span 10;
    }

    iframe {
      min-height: 100vh;
      position: relative;
      width: 100%;
      z-index: 0;
    }
  }
`